module.exports = __webpack_public_path__ + "static/img/chanta (11).9490315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (11).jpg
// module id = YCNR
// module chunks = 0